import { useCallback, useContext } from 'react'
import { StoreContext } from '../StoreProvider'
import { playerStoreInitialValues, playerStoreKey } from '../playerStore/playerStoreConstants'
import { updateZustandState } from '../storeUtils'
import { casinoStoreInitialValues, casinoStoreKey } from '../casinoStore/casinoStoreConstants'

export const useSetStoreDefaultData = () => {
  const { store } = useContext(StoreContext)

  const setStoreDefaultData = useCallback(
    (playerStoreData = {}, casinoStoreData = {}) => {
      store.setState(
        () => ({
          [playerStoreKey]: updateZustandState(playerStoreInitialValues, playerStoreData),
          [casinoStoreKey]: updateZustandState(casinoStoreInitialValues, casinoStoreData)
        }),
        false,
        'setStoreDefaultData'
      )
    },
    [store]
  )

  return { setStoreDefaultData }
}
